// extracted by mini-css-extract-plugin
export default {"Email":"NXPdnhQIFS8gm77Keu2v"};